import { css } from '@emotion/css';
import { AuthLoadingScreen } from '@medcom/shared-ui/components/AuthLoadingScreen.tsx';
import { forgetStoredUser } from '@medcom/shared-ui/utils/oidc.ts';
import { Flex, Result, theme } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { oidcConfig } from '../oidcConfig.ts';
import { takeAisLinkToken, takeLeftLinkSource } from './aisLinkToken';
import { AIS_TAB_NAME } from './aisSignin';

const INVALID_TEXT = 'Der Link ist ungültig. Bitte die Anforderung erneut aus dem AIS öffnen.';

const originOf = (url: string): string => {
  try {
    return new URL(url).origin;
  } catch {
    return '';
  }
};

// Keycloak signs in only when the link came from one of the vendor's origins; a reload of the own tab left a marker
const takeLinkSource = (token: string): string => {
  const marker = takeLeftLinkSource(token);
  const referrer = originOf(document.referrer);
  return referrer && referrer !== window.location.origin ? referrer : marker;
};

// The token is a bearer credential; index.tsx already took it out of the address bar, this strips the fallback
export const AisLinkRedeem = () => {
  const [token] = useState(takeAisLinkToken);
  const [source] = useState(() => takeLinkSource(token));
  const form = useRef<HTMLFormElement>(null);
  const { token: designToken } = theme.useToken();

  useEffect(() => {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    if (!token) return;
    // a reused tab may hold another user's tokens; without them the return visit signs in with the new session
    forgetStoredUser(oidcConfig);
    window.name = AIS_TAB_NAME;
    form.current?.submit();
  }, [token]);

  const containerStyle = css`
    padding: ${designToken.paddingXL}px;
  `;

  return token ? (
    <>
      <form ref={form} method="POST" action={`${window._env_.KEYCLOAK_URL}/realms/medcom/ais-login/redeem`}>
        <input type="hidden" name="token" value={token} />
        <input type="hidden" name="source" value={source} />
      </form>
      <AuthLoadingScreen signinRetry={false} />
    </>
  ) : (
    <Flex justify="center" className={containerStyle}>
      <Result status="warning" title="Laboranforderung aus dem AIS" subTitle={INVALID_TEXT} />
    </Flex>
  );
};
